module.exports = __webpack_public_path__ + "7c7449978df8dae582e82e220bb381ea.svg";